import { debounce } from 'lodash-es'
import { useDefaultModal } from '../defaultModal'
import Voucher from './voucher.vue'

export const useVoucher = debounce((success?: () => void) => {
  const cancel = () => {
    modal.destroy()
  }
  const modal = useDefaultModal({
    closable: true,
    center: true,
    header: false,
    footer: false,
    width: 500,
    content: <Voucher cancel={cancel} success={success} />,
  })
}, 200)
